var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLogoMixedLight = function SvgLogoMixedLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 61,
    viewBox: "0 0 214 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.3 14.8H98.2v3h18z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2 1h18v3H109q-.2 1.6-1.7 1.7-1.5-.1-1.6-1.7h-7.4z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.3 4.7c0 3.5-2.7 6.4-6 6.4-3.4 0-6-2.9-6-6.4h-3c0 5.3 4 9.5 9 9.5s9-4.2 9-9.5z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 17H1v.8h92.3z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.4 17h-92.1v.8h92.1z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m59 34.1 1 2.8h4.4l-6-15.8H54L48 37h4.3l1-2.8zm-1.1-3h-3.4l1.7-5.1z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3 30.7c2.2-.4 3.4-2.3 3.4-4.4 0-3.4-2.3-4.9-5.4-4.9H66v15.8h4.1V31l4 6h5zm-4-6.2h.3c1.4 0 2.9.3 2.9 2s-1.5 2-2.9 2h-.4z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m104.3 34.4 1 2.8h4.4l-6-15.8h-4.4l-6 15.8h4.3l1-2.8zm-1-3.1h-3.5l1.7-5z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.9 21.4h-4v15.8h4z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m161 34.4 1 2.8h4.4l-6-15.8H156l-6 15.8h4.3l1-2.8zm-1-3.1h-3.5l1.7-5z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21.8a8.5 8.5 0 0 0-9.7 1.7 8 8 0 0 0-2.4 5.8q0 3.5 2.5 6a9 9 0 0 0 5.9 2.3c1.3 0 2.2-.3 3.6-.7v-5q-1.5 1.6-3.5 1.7a4 4 0 0 1-4.3-4.3c0-2.4 1.7-4.3 4.2-4.3q2.3 0 3.6 1.7v-4.9",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.2 21.4h-4.5l6.6 15.8h3.2l6.7-15.8h-4.4L124 31z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1 24.9h3.4v-3.5h-10.8V25h3.4v12.3h4z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m11 54 1 2.6h4l-5.5-15.4h-4L.8 56.6h4l1-2.7zm-1-3.1H6.9l1.5-5z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m11 54 1 2.6h4l-5.5-15.4h-4L.8 56.6h4l1-2.7zm-1-3.1H6.9l1.5-5z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50.3c2.1-.4 3.2-2.2 3.2-4.3 0-3.3-2.1-4.8-5-4.8h-5.6v15.4h3.8v-6l3.5 6h4.7zm-3.6-6h.3c1.2 0 2.6.2 2.6 2 0 1.6-1.4 1.8-2.6 1.8h-.3z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50.3c2.1-.4 3.2-2.2 3.2-4.3 0-3.3-2.1-4.8-5-4.8h-5.6v15.4h3.8v-6l3.5 6h4.7zm-3.6-6h.3c1.2 0 2.6.2 2.6 2 0 1.6-1.4 1.8-2.6 1.8h-.3z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 41.6a8 8 0 0 0-8.9 1.7 8 8 0 0 0-2 5.6A8 8 0 0 0 36 57c1.2 0 2-.3 3.3-.7v-4.8Q38 53 36.1 53.1c-2.3 0-3.9-1.7-3.9-4.1 0-2.5 1.6-4.3 3.9-4.3a4 4 0 0 1 3.2 1.7z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m50 54 1 2.6h4l-5.4-15.4h-4.1L40 56.6h4l1-2.7zm-1-3.1h-3l1.5-5z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m50 54 1 2.6h4l-5.4-15.4h-4.1L40 56.6h4l1-2.7zm-1-3.1h-3l1.5-5z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m70.5 54 1 2.6h4L70 41.2h-4l-5.6 15.4h4l1-2.7zm-1-3.1h-3l1.5-5z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m70.5 54 1 2.6h4L70 41.2h-4l-5.6 15.4h4l1-2.7zm-1-3.1h-3l1.5-5z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6 42.1a9 9 0 0 0-4.6-1.3c-2.8 0-5 2-5 5.2 0 3.1 1.6 3.6 4 4.3.8.3 2.2.7 2.2 1.8s-.9 1.5-1.8 1.5q-1.9-.1-3.3-1.6l-1.6 3.3q2.3 1.6 5 1.7 2.3 0 4.2-1.4 1.5-1.6 1.4-4.2c0-2.4-1.5-3.5-3.5-4.2l-1-.3c-.6-.2-1.6-.5-1.6-1.4 0-1 .9-1.3 1.6-1.3q1.4 0 2.4 1z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8 42.1q-2.1-1.2-4.5-1.3c-2.9 0-5 2-5 5.2 0 3.1 1.6 3.6 4 4.3.7.3 2.2.7 2.2 1.8s-1 1.5-1.8 1.5q-2-.1-3.3-1.6l-1.6 3.3q2.3 1.6 5 1.7 2.4 0 4.1-1.4 1.7-1.6 1.5-4.2c0-2.4-1.5-3.5-3.5-4.2l-1-.3c-.6-.2-1.6-.5-1.6-1.4 0-1 .9-1.3 1.6-1.3q1.4 0 2.4 1z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 41.2h-3.8v15.4h3.8z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M114.7 41.6a8 8 0 0 0-8.9 1.7 8 8 0 0 0-2.2 5.6 8 8 0 0 0 7.8 8.1q1.5 0 3.3-.7v-4.8q-1.3 1.5-3.3 1.6c-2.3 0-3.9-1.7-3.9-4.1 0-2.5 1.6-4.3 3.9-4.3a4 4 0 0 1 3.3 1.7z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M125.2 41.2v8.1c0 2-.1 4.2-2.5 4.2s-2.5-2.2-2.5-4.2v-8h-3.8v8.6c0 2 .1 3.9 1.5 5.4 1.2 1.2 3.1 1.7 4.8 1.7s3.6-.4 4.8-1.7c1.4-1.5 1.5-3.5 1.5-5.4v-8.7z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.3 50.3c2-.4 3.2-2.2 3.2-4.3 0-3.3-2.2-4.8-5-4.8h-5.6v15.4h3.7v-6l3.6 6h4.6zm-3.7-6h.4c1.2 0 2.6.2 2.6 2 0 1.6-1.4 1.8-2.6 1.8h-.4z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138.3 50.3c2-.4 3.2-2.2 3.2-4.3 0-3.3-2.2-4.8-5-4.8h-5.6v15.4h3.7v-6l3.6 6h4.6zm-3.7-6h.4c1.2 0 2.6.2 2.6 2 0 1.6-1.4 1.8-2.6 1.8h-.4z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m152.2 54 1 2.6h4l-5.5-15.4h-4L142 56.6h4l1-2.7zm-1-3.1H148l1.5-5z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m152.2 54 1 2.6h4l-5.5-15.4h-4L142 56.6h4l1-2.7zm-1-3.1H148l1.5-5z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m163.1 53.2 6.8-12h-12v3.4h5.7l-6.8 12h12.3v-3.4z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M174.6 41.2h-3.7v15.4h3.7z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 40.7a8 8 0 0 0-7.9 8c0 4.9 3.3 8.4 8 8.4 4.6 0 7.9-3.5 7.9-8.5a8 8 0 0 0-8-7.9m0 3.9c2.3 0 4.1 2 4.1 4 0 2.7-1.8 4.6-4 4.6s-4.1-2-4.1-4.6c0-2 1.8-4 4-4",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 40.7a8 8 0 0 0-7.9 8c0 4.9 3.3 8.4 8 8.4 4.6 0 7.9-3.5 7.9-8.5a8 8 0 0 0-8-7.9m0 3.9c2.3 0 4.1 2 4.1 4 0 2.7-1.8 4.6-4 4.6s-4.1-2-4.1-4.6c0-2 1.8-4 4-4",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193 56.6h3.7v-9.4l7 9.4h3.7V41.2h-3.8v9.4l-6.9-9.4H193z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 41.2h-3.7v15.4h3.7z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5 60.2H.9v.8h212.6z",
    fill: "white"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLogoMixedLight);
export default Memo;